<template>
  <v-row>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Add Redirect
        </gg-card-header>
        <gg-card-text>
          <add-redirect-form @redirect-added="loadRedirects"></add-redirect-form>
        </gg-card-text>
      </gg-card>
    </v-col>
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          <v-row>
            <v-col cols="12" md="6">
              Manage Redirects
            </v-col>
            <v-col cols="12" md="6" class="font-weight-regular">
              <gg-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Search"
                hide-details
              />
            </v-col>
          </v-row>
        </gg-card-header>
        <gg-card-text>
          <redirects-table :search="search" ref="redirectsTable" />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import AddRedirectForm from '@/components/Services/Hosting/Shared/Domains/Redirects/AddRedirectForm'
import RedirectsTable from '@/components/Services/Hosting/Shared/Domains/Redirects/RedirectsTable'

export default {
  name: 'RedirectsView',
  components: {
    AddRedirectForm,
    RedirectsTable,
  },
  data () {
    return {
      search: ''
    }
  },
  methods: {
    loadRedirects () {
      this.$refs.redirectsTable.loadData()
    }
  },
}
</script>
